module.exports = __webpack_public_path__ + "static/media/NIFTYBEES.5076fc8a.txt";